export const getEmail = () => {
    return localStorage.getItem('email') || null;
}

export const getUser = () => {
    return localStorage.getItem('userId') || null;
}

export const getToken = () => {
    return localStorage.getItem('token') || null;
}

export const getName = () => {
    return localStorage.getItem('name') || null;
}

export const getAvatarUrl = () => {
    return localStorage.getItem('avatarUrl') || null;
}

export const removeUserSession = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('avatarUrl');
}

export const setUserSession = (email, userId, token, name, avatarUrl) => {
    localStorage.setItem('email', email);
    localStorage.setItem('userId', userId);
    localStorage.setItem('token', token);
    localStorage.setItem('name', name);
    localStorage.setItem('avatarUrl', avatarUrl);
}

const DICTIONARIES_KEY = "dictionaries";

export const getDictionaries = () => {
    return JSON.parse(sessionStorage.getItem(DICTIONARIES_KEY)) || null;
}

export const setDictionaries = (dictionaries) => {
    sessionStorage.setItem(DICTIONARIES_KEY, JSON.stringify(dictionaries));
}

const JUMPS_TO_UPLOAD_KEY = "jumpsToUpload";

export const getJumpsToUpload = () => {
    return JSON.parse(localStorage.getItem(JUMPS_TO_UPLOAD_KEY)) || null;
}

export const setJumpsToUpload = (jumpsToUpload) => {
    localStorage.setItem(JUMPS_TO_UPLOAD_KEY, JSON.stringify(jumpsToUpload));
}

export const removeJumpsToUpload = () => {
    localStorage.removeItem(JUMPS_TO_UPLOAD_KEY);
}

const UNITS_KEY = "units";

export const setUnits = (units) => {
    localStorage.setItem(UNITS_KEY, units);
}

export const getUnits = () => {
    return localStorage.getItem(UNITS_KEY) || null;
}

const JUMP_NUMBERS_SET = "jumpNumbersSet";

export const getJumpNumbersSet = () => {
    return new Set(JSON.parse(sessionStorage.getItem(JUMP_NUMBERS_SET))) || null;
}

export const setJumpNumbersSet = (jumpNumbersSet) => {
    sessionStorage.setItem(JUMP_NUMBERS_SET, JSON.stringify(jumpNumbersSet));
}